import { createElement as rc, useContext } from 'react';
import PropTypes from 'prop-types';
import useActiveRecord from '../../../hooks/useActiveRecord';
import { TabVisibilityContext } from '../../layout/TabViewLayout/TabPanel';
import ApiSource from './ApiSource';
import ReaderEventsSource from './ReaderEventsSource';

const sources = { api: ApiSource, readerEvents: ReaderEventsSource };

/** Mount a named provider only while its selected record and tab are active.
 * Providers supply { records, viewReady, status, error } through their child callback.
 * Changing records unmounts the provider so subscriptions and requests are cleaned up.
 */
export default function ListDataSource({ hNode, children }) {
    const active = useActiveRecord();
    const visible = useContext(TabVisibilityContext);
    const Source = Object.hasOwn(sources, hNode.dataSource) && sources[hNode.dataSource];
    if (!Source)
        return children({ records: [], viewReady: true, error: `Unknown list data source: ${hNode.dataSource}` });
    if (!visible || active?.isNew || !active?.record?._id) return null;
    return rc(
        Source,
        {
            hNode,
            record: active.record,
            visible: true,
            key: `${active.formInstanceId}:${active.record._id}`
        },
        children
    );
}

ListDataSource.propTypes = { hNode: PropTypes.object.isRequired, children: PropTypes.func.isRequired };
